/*
 * @Author: Gyan
 * @Date: 2023-11-02 09:54:19
 * @LastEditors: Gyan
 * @LastEditTime: 2023-11-15 09:56:12
 * @FilePath: \dhr_frontend\src\routes\modules\materialManagement.js
 * @Description: 物资管理路由配置
 */
export default [
  {
    name: 'materialRequisition',
    path: '/materialManagement/requisition',
    component: () =>
      import('@/views/materialManagement/materialRequisition/list.vue'),
    meta: {
      title: '物资领用'
    }
  },
  {
    name: 'materialRequisitionDetail',
    path: '/materialManagement/requisition/detail',
    component: () =>
      import('@/views/materialManagement/materialRequisition/detail.vue'),
    meta: {
      parentAuth: '/materialManagement/requisition',
      title: '物资领用详情'
    }
  },
  {
    name: 'batchProcurement',
    path: '/materialManagement/batchProcurement',
    component: () => import('@/views/materialManagement/materialRequisition/batchProcurement.vue'),
    meta: {
      parentAuth: '/materialManagement/requisition',
      title: '批量采购'
    }
  },
  {
    name: 'warehousing',
    path: '/materialManagement/warehousing',
    component: () => import('@/views/materialManagement/warehousing/list.vue'),
    meta: {
      title: '物资入库'
    }
  },
  {
    name: 'warehousingDetail',
    path: '/materialManagement/warehousing/detail',
    component: () => import('@/views/materialManagement/warehousing/detail.vue'),
    meta: {
      parentAuth: '/materialManagement/warehousing',
      title: (route)=>route.query?.isEditState=='true'?'新建入库':'入库详情'
    },
    props:(route)=>({
      ...route.query
    })
  },
  {
    name: 'inventory',
    path: '/materialManagement/inventory/list',
    component: () => import('@/views/materialManagement/inventory/list.vue'),
    meta: {
      title: '库存管理'
    }
  },
  {
    name: 'inventoryDetail',
    path: '/materialManagement/inventory/detail',
    component: () => import('@/views/materialManagement/inventory/detail.vue'),
    meta: {
      parentAuth: '/materialManagement/inventory/list',
      title: '库存详情'
    }
  },
  {
    name: 'outboundRecords',
    path: '/materialManagement/outboundRecords/list',
    component: () => import('@/views/materialManagement/outboundRecords/list.vue'),
    meta: {
      title: '出库记录'
    }
  },
  {
    name: 'materialOutbound',
    path: '/materialManagement/outboundRecords/materialOutbound',
    component: () => import('@/views/materialManagement/outboundRecords/materialOutbound.vue'),
    meta: {
      parentAuth: '/materialManagement/outboundRecords/list',
      title: '物资出库'
    }
  },
  {
    name: 'materialOutboundAdd',
    path: '/materialManagement/outboundRecords/materialOutboundAdd',
    component: () => import('@/views/materialManagement/outboundRecords/materialOutbound.vue'),
    meta: {
      parentAuth: '/materialManagement/outboundRecords/list',
      title: '物资出库'
    }
  },
  {
    name: 'outboundRecordsDetail',
    path: '/materialManagement/outboundRecords/detail',
    component: () => import('@/views/materialManagement/outboundRecords/detail.vue'),
    meta: {
      parentAuth: '/materialManagement/outboundRecords/list',
      title: '出库详情'
    }
  },
];
